import React from 'react';
import { connect } from 'react-redux';
import LiabilitiesDetails from './LiabilitiesDetails';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import {FIELDS as GLOBAL_FILTER_PANEL_FIELDS} from '../filter/GlobalFilterPanel';

const PAGE_INTERNAL_IDS = [
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_ID,
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_COUNTRY_CODE
];
const log = new Logger('MAKING_TAX_DIGITAL_PAGE', LOG_LEVELS.DEBUG);


export class LiabilitiesPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pages: -1,
            loading: true,
            pageSize: 1000,
            count: 0,
            page: 1,
        };

    }
    UNSAFE_componentWillMount() {
        log.debug('componentWillMount()');
        log.clearDictionaryError(ALL_MESSAGES.MTD_VAT_NUMBET_NOTAUTH);
    }

    render() {
        log.debug('render(): ', this.props);

        return (
            <div  data-test="component-liabilities-page">
                    <LiabilitiesDetails
                        data={this.props.liabilitiesData}
                        pageSizeOptions={[1000, 2000, 5000, 10000]}
                        defaultPageSize={this.state.pageSize}
                    />
                <div className="clear"></div>
            </div>
        );
    }
}

LiabilitiesPage.defaultProps = {
    filterCriteria: {},
    isReportTypeChanged: false
};
// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    log.debug('mapStateToProps', state);
    return {
        languages: state.languages,
        liabilitiesData: (state.ukMTDVAT && state.ukMTDVAT.liabilities && state.ukMTDVAT.liabilities.liabilities) || [],
        companies: (state.companies && state.companies.data ) || []
    };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(LiabilitiesPage);